<template>
  <div data-testid="verify-email" class="code-confirm">
    <div class="inputs-block">
      <form @submit.prevent="null">
        <input type="text" id="input-code" name="input-code" :autofocus="true" :maxlength="codeLength + 1" @focus="state.isFocus = true" @blur="state.isFocus = false" :value="modelValue" @input="textUpdate($event.target.value)" />
      </form>
      <label
        v-for="elt in codeLength"
        :key="elt"
        for="input-code"
        :id="`number-${elt}`"
        class="number-container"
        :class="{
          focus: modelValue.length + 1 === elt && state.isFocus,
          fill: modelValue.length + 1 > elt && state.isFocus,
        }"
      >
        {{ modelValue[elt - 1] }}
      </label>
    </div>
  </div>
</template>

<script setup lang="ts">
import { reactive } from "vue";

const codeLength = 8;

const emits = defineEmits(["update:modelValue"]);

const state = reactive({
  code: "",
  isFocus: true,
  lastCodeSubmit: null,
});

const props = defineProps<{
  isLoading: boolean,
  modelValue: string;
}>();

function textUpdate(text: string) {
  let normalizedText = text.replace(/[^a-zA-Z0-9]/g, "");
  if (normalizedText.length > codeLength) {
    normalizedText = normalizedText.slice(0, codeLength);
  }
  emits('update:modelValue', normalizedText);
}

</script>
